const NO_PREFERRED_STYLE_VALUE = "원하는 스타일 없음";

const LEGACY_PREFERRED_STYLE_VALUES = [
  "심플",
  "화려한",
  "클래식",
  "유니크",
  "유니크한",
];

const COMPARISON_ESTIMATE_STYLE_LABEL_MAP = new Map([
  ["클래식", "클래식함"],
  ["클래식함", "클래식함"],
  ["심플", "심플함"],
  ["심플함", "심플함"],
  ["화려한", "화려함"],
  ["화려함", "화려함"],
  ["유니크", "유니크함"],
  ["유니크한", "유니크함"],
  ["유니크함", "유니크함"],
]);

const comparisonEstimateStyleGroups = [
  {
    key: "classic",
    label: "클래식함",
    products: [
      {
        id: "6a1a7d8413019e6e5d2e0543",
        name: "켈리",
        providerName: "아주프라이빗",
        imageUrl:
          "https://hidia-storage.s3.ap-northeast-2.amazonaws.com/images/file-1788056136970.png",
      },
      {
        id: "6a056b868582611c75fe679d",
        name: "클루 Clew",
        providerName: "백작피렌체 청담점",
        imageUrl:
          "https://hidia-storage.s3.ap-northeast-2.amazonaws.com/images/file-1778740084619.jpeg",
      },
      {
        id: "69e9d6e980f5643be1049d08",
        name: "상또앙헬",
        providerName: "새미쥬얼리 종로점",
        imageUrl:
          "https://hidia-storage.s3.ap-northeast-2.amazonaws.com/images/file-1776932548462.jpeg",
      },
      {
        id: "69e9f01280f5643be104a1d0",
        name: "리플",
        providerName: "영신주얼리 종로점",
        imageUrl:
          "https://hidia-storage.s3.ap-northeast-2.amazonaws.com/images/file-1776939524464.png",
      },
    ],
  },
  {
    key: "simple",
    label: "심플함",
    products: [
      {
        id: "69fc193e26dd62e0ba89cc1e",
        name: "리네마",
        providerName: "디유953 청담점",
        imageUrl:
          "https://hidia-storage.s3.ap-northeast-2.amazonaws.com/images/file-1778129121394.jpeg",
      },
      {
        id: "6a17bab521c6db4ae966001c",
        name: "룩스",
        providerName: "비모던 종로점",
        imageUrl:
          "https://hidia-storage.s3.ap-northeast-2.amazonaws.com/images/file-1779940010918.jpeg",
      },
      {
        id: "6a1a7c2e13019e6e5d2e04fb",
        name: "타임리스",
        providerName: "아주프라이빗",
        imageUrl:
          "https://hidia-storage.s3.ap-northeast-2.amazonaws.com/images/file-1788056225670.png",
      },
      {
        id: "6a1a798513019e6e5d2e04d5",
        name: "오로라",
        providerName: "아주프라이빗",
        imageUrl:
          "https://hidia-storage.s3.ap-northeast-2.amazonaws.com/images/file-1788056680180.png",
      },
    ],
  },
  {
    key: "ornate",
    label: "화려함",
    products: [
      {
        id: "69e9d44d80f5643be1049bd4",
        name: "로코코",
        providerName: "새미쥬얼리 종로점",
        imageUrl:
          "https://hidia-storage.s3.ap-northeast-2.amazonaws.com/images/file-1776931850837.jpeg",
      },
      {
        id: "69e9f0a380f5643be104a1fd",
        name: "에테르노",
        providerName: "영신주얼리 종로점",
        imageUrl:
          "https://hidia-storage.s3.ap-northeast-2.amazonaws.com/images/file-1776939476018.png",
      },
      {
        id: "6a796cec31875af332a1fdf3",
        name: "1캐럿 천연다이아몬드 14k 18k 6발 심플 웨딩 예물 결혼 반지 위니 HNDR1C282",
        providerName: "하나다이아몬드 종로점",
        imageUrl:
          "https://hidia-storage.s3.ap-northeast-2.amazonaws.com/images/file-1786957665348.png",
      },
      {
        id: "6a82e3742ca41132da61a547",
        name: "5부 천연다이아몬드 반지 [예티] 기념일 예물 프로포즈 선물 HNDR07205",
        providerName: "하나다이아몬드 종로점",
        imageUrl:
          "https://hidia-storage.s3.ap-northeast-2.amazonaws.com/images/file-1786962543894.png",
      },
    ],
  },
  {
    key: "unique",
    label: "유니크함",
    products: [
      {
        id: "69e9d13480f5643be1049a42",
        name: "단청",
        providerName: "새미쥬얼리 종로점",
        imageUrl:
          "https://hidia-storage.s3.ap-northeast-2.amazonaws.com/images/file-1776931013496.jpeg",
      },
      {
        id: "6a056cfa8582611c75fe67fa",
        name: "쿠론  Couronne",
        providerName: "백작피렌체 청담점",
        imageUrl:
          "https://hidia-storage.s3.ap-northeast-2.amazonaws.com/images/file-1778740463805.jpeg",
      },
      {
        id: "6a056b418582611c75fe6784",
        name: "콜로세움 Colosseum",
        providerName: "백작피렌체 청담점",
        imageUrl:
          "https://hidia-storage.s3.ap-northeast-2.amazonaws.com/images/file-1778740020199.jpeg",
      },
      {
        id: "69e9d1b180f5643be1049a68",
        name: "라데팡스",
        providerName: "새미쥬얼리 종로점",
        imageUrl:
          "https://hidia-storage.s3.ap-northeast-2.amazonaws.com/images/file-1776931208957.jpeg",
      },
    ],
  },
];

const productById = new Map(
  comparisonEstimateStyleGroups.reduce(
    (entries, group) =>
      entries.concat(
        group.products.map((product) => [
          product.id,
          { ...product, style: group.label },
        ])
      ),
    []
  )
);
const validValues = new Set([
  NO_PREFERRED_STYLE_VALUE,
  ...LEGACY_PREFERRED_STYLE_VALUES,
  ...COMPARISON_ESTIMATE_STYLE_LABEL_MAP.keys(),
  ...productById.keys(),
]);

function normalizeComparisonPreferredDesigns(values) {
  if (!Array.isArray(values)) return [];
  const normalized = [...new Set(values.map(String).map((value) => value.trim()))]
    .filter(Boolean)
    .filter((value) => validValues.has(value));
  if (normalized.includes(NO_PREFERRED_STYLE_VALUE)) {
    return [NO_PREFERRED_STYLE_VALUE];
  }
  return normalized;
}

function hasNoPreferredStyle(values) {
  return normalizeComparisonPreferredDesigns(values).includes(
    NO_PREFERRED_STYLE_VALUE
  );
}

function getComparisonPreferredProducts(values) {
  return normalizeComparisonPreferredDesigns(values)
    .map((value) => productById.get(value))
    .filter(Boolean)
    .map((product) => ({ ...product }));
}

function getComparisonPreferredDesignLabel(value) {
  const normalized = String(value || "").trim();
  if (normalized === NO_PREFERRED_STYLE_VALUE) return NO_PREFERRED_STYLE_VALUE;
  if (COMPARISON_ESTIMATE_STYLE_LABEL_MAP.has(normalized)) {
    return COMPARISON_ESTIMATE_STYLE_LABEL_MAP.get(normalized);
  }
  const product = productById.get(normalized);
  if (!product) return normalized;
  return `${product.name} (${product.providerName})`;
}

function formatComparisonPreferredDesigns(values) {
  return [
    ...new Set(
      normalizeComparisonPreferredDesigns(values)
        .map(getComparisonPreferredDesignLabel)
        .filter(Boolean)
    ),
  ].join(", ");
}

module.exports = {
  NO_PREFERRED_STYLE_VALUE,
  comparisonEstimateStyleGroups,
  formatComparisonPreferredDesigns,
  getComparisonPreferredProducts,
  getComparisonPreferredDesignLabel,
  hasNoPreferredStyle,
  normalizeComparisonPreferredDesigns,
};
